// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//引入路由
import router from './router'
//引入store
import store from '../store/store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


import 'view-design/dist/styles/iview.css';
import { Menu, MenuItem, Icon, MenuGroup, Submenu, Dropdown, DropdownMenu, DropdownItem, Drawer, Button, Cell, CellGroup} from 'view-design';
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Icon', Icon);
Vue.component('MenuGroup', MenuGroup);
Vue.component('Submenu', Submenu);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Drawer', Drawer);
Vue.component('Button', Button);
Vue.component('Cell', Cell);
Vue.component('CellGroup', CellGroup);

//引入axios
import axios from 'axios'
axios.defaults.baseURL="http://127.0.0.1:8080/"
//注册axios
Vue.prototype.axios = axios
//设置跨域
axios.defaults.withCredentials = true
//引用elementUI
Vue.use(ElementUI)

import MyHeader from './components/Header.vue'
//注册全局组件
Vue.component("my-header", MyHeader)

//注册底部
import MyFoot from './components/Foot.vue'
Vue.component("my-foot", MyFoot)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js